import React from "react";
import Prediction from "./Prediction";

const App = () => {
  return <Prediction />;
};

export default App;
